import React, {FC} from 'react';
import {toAbsoluteUrl} from "../../helpers";
import {NavLink} from "react-router-dom";
import {useCart} from "../../context/CartContext";

type Props = {
    slug?: any
    products?: any
    currentRoute?: any
    isAdded?: boolean
    className?: any
}

const CartButton: FC<Props> = ({slug, products, currentRoute, isAdded, className}) => {
    const {getTotalItems} = useCart();

    return (
        <NavLink className={`${className} ms-2 mt-2 nav-link cart-link`} to="/purchase">
            {currentRoute !== '/payment/approved' && currentRoute !== '/payment/cancelled' ?
                <div className={'position-relative'}>
                    <img src={toAbsoluteUrl('/assets/images/icons/cart.png')} width={'20'} className={'cart'}
                         alt={'Cart'}/>
                    {products && products.length > 0 &&
                        <div className={`cart-items-count ${isAdded ? 'active' : ''}`}>
                                               <span>
                                                 {getTotalItems()}
                                               </span>
                        </div>
                    }
                </div>

                :

                <img src={toAbsoluteUrl('/assets/images/icons/cart.png')} width={'20'} className={'cart'}
                     alt={'Cart'}/>


            }
        </NavLink>
    );
};

export default CartButton;